import { observer } from "mobx-react";
import emailCustomizationStore from "../../stores/email-customization-store";
import "./logo-preview.scss";
import FontHeading2 from "../../../../components/fonts/font-heading2/font-heading2";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import currentPortalStore from "../../../../stores/current-portal-store";
import { ButtonIcon } from "../../../../components/inputs/button-icon/button-icon";
import IconDelete from "../../../../components/icons/icon-delete/icon-delete";
import { ConfirmModal } from "../../../../components/modal/components/confirm-modal/confirm-modal";
import { useState } from "react";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";

const LogoPreview: React.FC = observer(() => {
    const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false);
    const getPlaceholder = () => {
        return <div className="placeholder">
            <FontHeading2 variant={FONT_VARIANT.BOLD} color={FONT_COLOR.NEUTRAL10}>
                {currentPortalStore.currentPortal.name}
            </FontHeading2>
        </div>
    }

    const deleteLogo = () => {
        emailCustomizationStore.deleteLogo();
        setIsShowConfirmDelete(false);
    }

    return <div className={`logo-preview-container ${emailCustomizationStore.logoAlign}`}>
        {!emailCustomizationStore.isLoading && (emailCustomizationStore?.logo ?
            <div className="logo-container">
                <div className="logo">
                    <img src={emailCustomizationStore.logo} alt="logo" />
                    <ButtonIcon
                        Component={IconDelete}
                        color="var(--color-accent-3)"
                        onClick={() => setIsShowConfirmDelete(true)}
                        disabled={emailCustomizationStore.isLoading || emailCustomizationStore.isSaving()}
                    />
                </div>
                <FontBody2 color={FONT_COLOR.PRIMARY3_50}>
                    Image size {emailCustomizationStore.logoOriginalDimensions}
                </FontBody2>
            </div>
            : getPlaceholder())}
        {isShowConfirmDelete &&
            <ConfirmModal
                title='Delete Email Logo'
                text='Are you sure you want to delete the email logo'
                cancelButton={{
                    title: 'Cancel',
                    onClick: () => setIsShowConfirmDelete(false)
                }}
                okButton={{
                    title: 'Delete',
                    onClick: deleteLogo
                }}
            />
        }
    </div>
});

export default LogoPreview;
